export default __webpack_public_path__ + "aws.9e104a77.png";